var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPhoto = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5C3.3 2 2 3.3 2 5V19C2 20.7 3.3 22 5 22H19C20.7 22 22 20.7 22 19V5C22 3.3 20.7 2 19 2ZM4 5C4 4.4 4.4 4 5 4H19C19.6 4 20 4.4 20 5V12.6L16.7 9.3C16.3 8.9 15.7 8.9 15.3 9.3L4.7 19.9C4.3 19.8 4 19.4 4 19V5ZM19 20H7.4L16 11.4L20 15.4V19C20 19.6 19.6 20 19 20ZM8.5 11C9.9 11 11 9.9 11 8.5C11 7.1 9.9 6 8.5 6C7.1 6 6 7.1 6 8.5C6 9.9 7.1 11 8.5 11ZM8.5 8C8.8 8 9 8.2 9 8.5C9 8.8 8.8 9 8.5 9C8.2 9 8 8.8 8 8.5C8 8.2 8.2 8 8.5 8Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPhoto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconPhoto.5a538e9923a69f02484f4da2d365447d.svg";